import { ADMINISTRATIVE_AREA_LEVEL_1_LABELS, ADDRESS_REGION, ADDRESS_REGION_PLURAL } from 'app/constants';

export const getAdminLevel1Label = (countryCode, plural) => {
  let label;
  if (typeof ADMINISTRATIVE_AREA_LEVEL_1_LABELS[countryCode] == 'object') {
    label = ADMINISTRATIVE_AREA_LEVEL_1_LABELS[countryCode][plural ? 'plural' : 'singular'];
  } else {
    label = ADMINISTRATIVE_AREA_LEVEL_1_LABELS[countryCode];
    if (label && plural) label = `${label}s`;
  }
  if (!label) label = plural ? ADDRESS_REGION_PLURAL : ADDRESS_REGION;
  return label;
};


export const getPostalCodeRegEx = (country) => {
  return (country === 'US') ?
    /^(\d{5}-\d{4}|\d{5})$/ :
    '';
};



// WEBPACK FOOTER //
// ./src/app/admin/services/utils/address.js